import { Typography } from "@povio/ui";
import clsx from "clsx";
import { ListBoxItem as AriaListBoxItem } from "react-aria-components";

import { CheckboxCheckmark } from "@/components/ui/inputs/Checkbox/CheckboxCheckmark";

import type { DropdownItem } from "./Dropdown";

export const DropdownListItem = (item: DropdownItem) => {
  return (
    <AriaListBoxItem
      id={item.id}
      aria-label={item.label}
      aria-labelledby={item.label}
      className={clsx(
        "group flex cursor-pointer items-center gap-2 px-4 py-2",
        "outline-hidden",
        "text-neutral-100",
        "hover:bg-secondary-200",
        "focus-visible:bg-secondary-200 focus-visible:text-secondary-50",
        "selected:bg-secondary-200 selected:text-secondary-50",
      )}
    >
      <CheckboxCheckmark
        variant="default"
        className="group-data-[selection-mode='single']:hidden"
      />
      <Typography
        size="label-1"
        as="span"
      >
        {item.label}
      </Typography>
    </AriaListBoxItem>
  );
};
